import Vue from 'vue';
import Router from 'vue-router';

Vue.use( Router );

let appRouter = new Router({
    mode: 'history',
    routes: [
        // generated-routes
        {
            path: '/',
            name: 'Landing',
            component: () =>
            {
                return import( /* webpackChunkName: "landing" */ '@/app/pages/Landing' );
            }
        },
        {
            path: '/video',
            name: 'Video',
            component: () =>
            {
                return import( /* webpackChunkName: "video" */ '@/app/pages/Video' );
            }
        },
        {
            path: '/form',
            name: 'Form',
            component: () =>
            {
                return import( /* webpackChunkName: "form" */ '@/app/pages/Form' );
            }
        },
        {
            path: '/scan',
            name: 'Scan',
            component: () =>
            {
                return import( /* webpackChunkName: "scan" */ '@/app/pages/Scan' );
            }
        },
        {
            path: '/bedankt',
            name: 'Thanks',
            component: () =>
            {
                return import( /* webpackChunkName: "thanks" */ '@/app/pages/Thanks' );
            }
        }
    ]
});

appRouter.beforeEach( ( to, from, next ) =>
{
    if( typeof to.beforeEnter === 'function' ) // check if the route has a beforeEnter function
    {
        to.beforeEnter( to, from, next );
        return;
    }

    next();
});

export default appRouter;
